module.exports = __webpack_public_path__ + "img/icon_investmezzanine_process_01.14637844.svg";